<template>
    <div v-if="!mobile"  style="height: 100vh">
        <div id="index" ref="appRef">
            <div class="bg">
                <dv-loading v-if="loading">Loading...</dv-loading>
                <div v-else class="host-body">
                    <div class="d-flex jc-center">
                        <dv-decoration-10 class="dv-dec-10"/>
                        <div class="d-flex jc-center">
                            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#000000']"/>
                            <div class="title">
<!--                                <span class="title-text">潍坊市单病种群体管理实时数据</span>-->
                                <span class="title-text">滨城区三高共管六病同防实时数据</span>
                                <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']"/>
                            </div>
                            <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="['#568aea', '#000000']"/>
                        </div>
                        <dv-decoration-10 class="dv-dec-10-s"/>
                    </div>

                    <!-- 第二行 -->
                    <div class="d-flex jc-between px-2">
                        <div class="d-flex aside-width">
                            <div class="react-left ml-4 react-l-s" style="width: 255px;">
                                <span class="react-before"></span>
                                <span class="text fw-b">{{ title }}</span>
                            </div>
                            <div class="react-right ml-3">
							<span class="text fw-b">
								管理病种：{{bingzs}}个
								<font style="margin-left: 10px; margin-right: 10px;">&nbsp;</font>
								医师：{{doctors}}人
							</span>
                            </div>
                        </div>
                        <div class="d-flex aside-width">
                            <div class="react-right mr-3"><!-- <span class="text fw-b">大数据可视化平台</span> --></div>
                            <div class="react-right mr-4 react-l-s">
                                <span class="react-after"></span>
                                <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="body-box">
                        <!-- 第三行数据 -->
                        <div class="content-box-qy">
                            <div>
                                <dv-border-box-12>
                                    <Left1/>
                                </dv-border-box-12>
                            </div>
                            <!--						<div><centerLeft2 /></div>-->
                            <div>
                                <dv-border-box-12>
                                    <center/>
                                </dv-border-box-12>
                            </div>
                            <div>
                                <dv-border-box-12>
                                    <topRight2/>
                                </dv-border-box-12>
                            </div>
                        </div>
                        <!-- 第四行数据 -->
                        <div class="bototm-box">
                            <dv-border-box-13>
                                <Right2/>
                            </dv-border-box-13>
                            <dv-border-box-13>
                                <bottomLeft/>
                            </dv-border-box-13>
                            <dv-border-box-12>
                                <bottomRight/>
                            </dv-border-box-12>
                            <dv-border-box-13>
                                <BottomRight3/>
                            </dv-border-box-13>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div style="display: flex;flex-direction: column;justify-content: center;color: white;">
            <div style="display: flex;flex-direction: row;justify-content: center">
                <span class="line"/>
                <span style="color: white;font-size: 15px;font-weight:bold;margin: 10px">潍坊市单病种群体管理实时数据</span>
                <span class="line"/>
            </div>
            <span style="color: white;font-size: 13px;text-align: center">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
            <div style="display: flex;justify-content: center;margin-top: 5px;">
                <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']"/>
            </div>
            <div style="display: flex;justify-content: space-between;flex-direction: row;margin-left: 20px;margin-right: 20px;margin-top: 5px">
                <span style="color: white;font-size: 13px;">{{ title }}</span>
                <span style="color: white;font-size: 13px;">管理病种：{{bingzs}}个<font
                        style="margin-left: 5px; margin-right: 5px;">&nbsp;</font>
								医师：{{doctors}}人</span>
            </div>
            <div style="width: 100%;">
                <Left1/>
            </div>
            <div style="width: 100%;">
                <center/>
            </div>
            <div style="width: 100%;">
                <topRight2/>
            </div>
            <div style="width: 100%;">
                <Right2/>
            </div>
            <div style="width: 100%;">
                <bottomLeft/>
            </div>
            <div style="width: 100%;">
                <bottomRight/>
            </div>
            <div style="width: 100%;">
                <BottomRight3/>
            </div>
        </div>
    </div>
</template>

<script>
    import BottomRight3 from './components/bottomright3qy';
    import Right2 from './components/right2qy';
    import Left1 from './components/leftqy';
    import drawMixin from '../utils/drawMixin';
    import {formatTime} from '../utils/index.js';
    import centerLeft2 from './centerLeft2qy';
    import center from './centerwjwqy';
    import bottomLeft from './bottomLeftbzqy';
    import bottomRight from './bottomRightqy';
    import topRight2 from './topright2qy.vue';
    import request from '@/utils/request';
    import jnpf from "@/utils/jnpf";

    export default {
        mixins: [drawMixin],
        data() {
            return {
                mobile: false,
                timing: null,
                loading: true,
                dateDay: null,
                dateYear: null,
                dateWeek: null,
                weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                count: '',
                doctors: "",
                title: "",
                bingz: ""
            };
        },
        components: {
            Left1,
            Right2,
            BottomRight3,
            centerLeft2,
            center,
            bottomLeft,
            bottomRight,
            topRight2
        },
        created() {
            if (this.$route.query.name != undefined) {
                if (this.$route.query.level == '2') {
                    this.title = this.$route.query.name + '卫生健康局'
                } else {
                    this.title = this.$route.query.name
                }
            } else {
                this.title = '潍坊市卫生健康委员会'
            }
        },
        mounted() {
            this.mobile = jnpf.isMobile()
            console.log("当前环境="+this.mobile?"手机端":"电脑端")
            this.timeFn();
            this.cancelLoading();
            this.clickJump();
            this.getUser();
            this.getBz()
        },
        beforeDestroy() {
            clearInterval(this.timing);
        },
        methods: {
            clickJump() {
                // const timejump = 300;
                // if (!this.timer) {
                // 	this.count = timejump;
                // 	this.show = false;
                // 	this.timer = setInterval(() => {
                // 		if (this.count > 0 && this.count <= timejump) {
                // 			this.count--;
                // 		} else {
                // 			this.show = true;
                // 			clearInterval(this.timer);
                // 			this.timer = null;
                // 			//跳转的页面写在此处
                // 			this.$router.push({ path: '/indexaqother' });
                // 		}
                // 	}, 100);
                // }
            },
            getUser() {
                let code = this.$route.query.code;
                let area = this.$route.query.area;
                if (code == undefined) {
                    code = ""
                }
                if (area == undefined) {
                    area = ""
                }
                request({
                    url: this.$root.api + `/api/dbz/daping/dpdbzysrstj`,
                    method: 'get',
                    data: {code: code, area: area}
                }).then(res => {
                    console.log("医生信息", res)
                    this.doctors = res.data
                })
            },
            getBz() {
                request({
                    url: this.$root.api + `/api/dbz/daping/dpdbzsltj`,
                    method: 'get',
                    data: {code: ""}
                }).then(res => {
                    console.log("bingzs---", res)
                    this.bingzs = res.data
                })
            },
            timeFn() {
                this.timing = setInterval(() => {
                    this.dateDay = formatTime(new Date(), 'HH: mm: ss');
                    this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
                    this.dateWeek = this.weekday[new Date().getDay()];
                }, 1000);
            },
            cancelLoading() {
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            }
        }
    };
</script>

<style lang="scss">
    @import '../assets/scss/index.scss';
    .line {
        width: 50px;
        height: 1px;
        margin-top: 20px;
        background: #568aea;
    }

    .dv-dec-6 {
        width: 200px;
        height: 8px;
    }

    .dv-dec-8 {
        width: 200px;
        height: 50px;
    }
</style>
